export default __webpack_public_path__ + "static/after-fe0449ed7952a50a54dd581281638ed3.jpg";